// Quaver/semiquaver beaming: group by beat (or half-bar in 4/4) and fit one sloped beam per group.
export const groupUnit = (time) => ({ "3/4": 1, "6/8": 1.5, "9/8": 1.5, "12/8": 1.5, "3/8": 1.5 }[time] || 2);

// items: [{ pos, len, beam }] in crotchet beats from the bar start; returns arrays of item indices (2+ notes).
export function beamGroups(items, unit) {
  const groups = [];
  let cur = [];
  const close = () => { if (cur.length > 1) groups.push(cur); cur = []; };
  items.forEach((it, i) => {
    if (!it.beam) { close(); return; }
    const prev = cur.length ? items[cur[cur.length - 1]] : null;
    const u = it.len < 0.5 || (prev && prev.len < 0.5) ? Math.min(unit, 1) : unit;
    const same = prev && Math.floor((prev.pos + 1e-6) / u) === Math.floor((it.pos + 1e-6) / u) && Math.abs(prev.pos + prev.len - it.pos) < 1e-6;
    if (!same) close();
    cur.push(i);
  });
  close();
  if (unit !== 2) return groups;
  // Half-bar beams only when the quavers fill the half bar; otherwise beam beat by beat.
  return groups.flatMap((g) => {
    const a = items[g[0]], z = items[g[g.length - 1]];
    const full = Math.abs((a.pos % 2)) < 1e-6 && Math.abs(z.pos + z.len - a.pos - 2) < 1e-6;
    if (full) return [g];
    const sub = [];
    g.forEach((i) => {
      const last = sub[sub.length - 1];
      if (last && Math.floor((items[last[0]].pos + 1e-6)) === Math.floor(items[i].pos + 1e-6)) last.push(i); else sub.push([i]);
    });
    return sub.filter((s) => s.length > 1);
  });
}

// notes: [{ x, top, bottom }] (stem x, highest and lowest notehead y). Returns { up, at(x) } for the beam line.
export function fitBeam(notes, up, stem = 34, maxRise = 8) {
  const ends = notes.map((n) => (up ? n.top - stem : n.bottom + stem));
  const x0 = notes[0].x, x1 = notes[notes.length - 1].x;
  const rise = Math.max(-maxRise, Math.min(maxRise, ends[ends.length - 1] - ends[0]));
  const slope = x1 === x0 ? 0 : rise / (x1 - x0);
  const offs = ends.map((e, k) => e - slope * (notes[k].x - x0));
  const b = up ? Math.min(...offs) : Math.max(...offs);
  return { up, at: (x) => b + slope * (x - x0) };
}

// Stems up if the note furthest from the middle line sits below it (larger y = lower).
export const groupUp = (notes, middle) => {
  const ys = notes.flatMap((n) => [n.top, n.bottom]);
  const far = ys.reduce((a, y) => (Math.abs(y - middle) > Math.abs(a - middle) ? y : a), ys[0]);
  return far >= middle;
};
